/**
 * Generated Version Information
 * DO NOT EDIT - This file is auto-generated by scripts/generate-version.ts
 */

export const VERSION = {
  appName: "optlab",
  env: "prod",
  gitSha: "5ac4e3d",
  buildTime: "2026-01-31T17:16:04.251Z",
} as const;
